// URL-only isolation for the unresolved physical-iPhone reload. Combat and 3D
// continue normally while HP decorations are removed; saves are unaffected.
export const usesPlainHealthBars = () =>
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('coreboundHealth') === 'plain';
